import { DiscoverComponent } from '@fluidx/discover';
import {
  InsertComponentRequestData,
  DataRequestProcessor,
  DataRequestCreator,
  ContainerManifestEntry,
  DiscoverData,
  DiscoverDataRequest
} from '@fluidx/office-fluid-types';
import { IFluidObject } from '@fluidframework/core-interfaces';

/**
 * This handler is the one that is responsible for keeping track of the current context of Discover UX.
 */
class DiscoverUXHandler {
  private discoverHandler: DataRequestProcessor & DataRequestCreator;
  private discoverData?: DiscoverData;

  constructor() {
    const menuServicePromise = import(/* webpackChunkName: "menu-view-service" */ '@fluidx/menu-view-service').then(
      (m) => new m.MenuService()
    );
    this.discoverHandler = new DiscoverComponent(undefined /*loggerPromise*/, menuServicePromise);
    this.discoverHandler.registerDataRequestCallback(this.producerCallback);
  }

  setDiscoverManifestEntries(entries: ContainerManifestEntry[]) {
    this.discoverData = entries;
  }

  showDiscoverMenu(requestData: InsertComponentRequestData) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.discoverHandler.processDataRequest('ComponentProduceInsertComponentRequestData', requestData);
  }

  private filterDiscoverData = (query: string): DiscoverData => {
    if (!this.discoverData) {
      return [];
    }
    return this.discoverData.filter((entry) => entry.queryableData.displayName.includes(query));
  };

  private producerCallback = (interfaceName: keyof IFluidObject, request: any) => {
    if (interfaceName === 'DiscoverData') {
      const typedRequest = request as DiscoverDataRequest;
      typedRequest.setDiscoverData(this.filterDiscoverData(typedRequest.searchQuery));
    }
  };
}

/** The instance of the discover handler. */
const discoverHandler = new DiscoverUXHandler();

/**
 * Renders Discover Menu which contains entries coming from a deployed manifest.
 * @param requestData A bag of property for creating / inserting Activity Blueprints or Components.
 */
export function showDiscoverMenuWithManifest(requestData: InsertComponentRequestData) {
  // External hosts do not currently want the search box in Discover, so let's make this false for all hosts
  requestData.hostContext.showSearch = false;
  discoverHandler.showDiscoverMenu(requestData);
}

export function setDiscoverManifestEntries(entries: ContainerManifestEntry[]) {
  discoverHandler.setDiscoverManifestEntries(entries);
}
